import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';

const firebaseConfig = {
  apiKey: "AIzaSyDEpUjjRACuwVhIJmGH2aTovGmVTngPML8",
  authDomain: "closingdaycanada.firebaseapp.com",
  projectId: "closingdaycanada",
  storageBucket: "closingdaycanada.firebasestorage.app",
  messagingSenderId: "388939333817",
  appId: "1:388939333817:web:9fb347a972ade7bccbdb68",
  measurementId: "G-JWP33SRVV2",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export default app;
